export const BASE_URL = "https://app.nikas.co.in";

export const API_ENDPOINTS = {
  login: "/rs/v2/userlogin",
  getDashboard: "/rs/getDashboard",
  getPathway: (course, syllabus, subject) =>
    `/rs/pathway/${course}/${syllabus}/${subject}`,
  fetchQuestion: "/rs/fetchQuestion",
  searchUsers: "/rs/searchMasterUser",
  searchGroups: "/rs/searchgroup",
  addUsersToGroup: "/rs/addUsersToGroup",
  createQuestionnaire: "/rs/createQuestionnaire",
  searchQuestions: "/rs/searchquestion",
  questionBankMonthYears: "/rs/questionbank/month-years",
  getAllAds: "/media/getAllAds",
  updateAd: "/media/updateAd",
  uploadAd: "/media/uploadAd",
  updateQuestionBank: "/rs/questionbankupdate",
  updateQuestion: "/rs/updateQuestion",
  updateQuestionImage: "/rs/question/image/update",
  updateOptionImage: "/rs/option/image/update",
  usersByDateRange: "/rs/byDateRange",
  manageContent: "/rs/managecontent",
  getAdminQuestionnaire: "/rs/getAdminQuestionnaire",
  getQuestionnaireAnalysis: (id) => `/rs/getQuestionnaireAnalysis/${id}`,
  getOverallUserStats: "/rs/getallusersstats",
  getLearningPathway: (course, syllabus, subject) =>
    `/rs/learningpathway/${course}/${syllabus}/${subject}`,
  getLearningPathways: "/rs/getlearningpathways",
  getColorCodes: "/rs/gettheme/ENOCH/admin",
  getMetadata: (path) => {
    let instCode = '';
    try {
      const authData = JSON.parse(localStorage.getItem('auth-storage'));
      instCode = authData?.state?.institution?.code || '';
    } catch (e) {
      console.warn('Error reading institution code', e);
    }
    const cleanPath = path?.startsWith('/') ? path.slice(1) : (path || '');
    return `/resource/content/${instCode}/${cleanPath}/metadata.json`;
  },
  getQuestionBankFile: (moduleTopicUuid, questionUuid, fileName) => {
    let instCode = '';
    try {
      const authData = JSON.parse(localStorage.getItem('auth-storage'));
      instCode = authData?.state?.institution?.code || '';
    } catch (e) {
      console.warn('Error reading institution code', e);
    }
    return `/resource/questionbank/${instCode}/${moduleTopicUuid}/${questionUuid}/${fileName}`;
  },
  getAllInstitutions: "/rs/getallinstitutions",
  createInstitution: "/rs/createUpdateInstitution",
  updateInstitution: "/rs/updateInstitution",
  deleteInstitution: (id) => `/rs/deleteInstitution/${id}`,
  moveQuestion: "/rs/moveQuestion",
  getTodayUserStats: "/rs/gettodayuserstats",
  getTempUsers: "/rs/getTempUsers",
  createMasterUser: "/rs/createMasterUser",
  guestAccess: "/rs/auth/guestaccess",
  questionnaireTemplate: "/rs/questionnaireTemplate",
  submitAnswer: "/rs/answer",
  getQaImages: (path) => `/rs/getqaimages/${path}`,
  refreshApp: "/rs/actuator/refresh",
  refreshAds: "/ads/actuator/refresh",
  refreshSubscription: "/sub/actuator/refresh",
  downloadQuestions: "/rs/downloadQuestions",
  getAdFile: (contentUrl, fileName) =>
    `/media/files/getadfiles/${contentUrl}/${fileName}`,
  createPrivilege: "/rs/createprivilege",
  getAllPrivileges: (institutionId) => `/rs/getallprivileges?institutionId=${institutionId}`,
  updatePrivilege: (id) => `/rs/updateprivileges/${id}`,
  deletePrivilege: (id, institutionId) => `/rs/deleteprivileges/${id}?institutionId=${institutionId}`,
  getAllRankPrivileges: (rankId, institutionId) => `/rs/getallrankprivileges?institutionId=${institutionId}&rankId=${rankId}`,
  assignRankPrivilege: "/rs/assignrankprivileges",
  getAssignedPrivileges: (institutionId) => `/rs/getassignedprivileges?institutionId=${institutionId}`,
  assignInstitutionPrivilege: "/rs/assigninstitutionprivileges",
  getInstitutionPrivileges: (institutionId) => `/rs/getinstitutionprivileges?institutionId=${institutionId}`,
  deleteInstitutionPrivilege: (id, institutionId) => `/rs/deleteinstitutionprivileges/${id}?institutionId=${institutionId}`,
  createHierarchy: "/rs/createHierarchy",
  getSubjectHierarchy: "/rs/getsubjecthierarchy",
  getPrometheusMetrics: "/rs/actuator/prometheus",
  getMetricsHistory: (endpoint, windowMinutes, stepSeconds) => `/rs/metrics/history?endpoint=${encodeURIComponent(endpoint)}&windowMinutes=${windowMinutes}&stepSeconds=${stepSeconds}`,
  createProduct: "/ms/createproduct",
  getSubscriptionContent: "/ms/subscription/hierarchy",
  getDefaultSubscription: "/products/defaultsubscription",
  getTrialSubscription: "/products/trial",
  getAllProducts: "/products/getallproducts",
  getProductImage: (imagePath) => {
    if (!imagePath) return '';
    if (imagePath.startsWith('/products/')) return imagePath;
    if (imagePath.startsWith('products/')) return `/${imagePath}`;
    const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
    return `/products/${cleanPath}`;
  },
  deleteProduct: (id) => `/ms/deleteproduct/${id}`,
  activateProduct: (id) => `/ms/activateproduct/${id}`,
  getProductDetails: (id) => `/products/getproductdetails/${id}`,
  updateProduct: (id) => `/ms/updateproduct/${id}`,
  updateProductPlans: (id) => `/ms/updateplan/${id}`,
  updateProductContent: (id) => `/ms/updatesubscriptioncontent/${id}`,
  updatePhysicalProduct: (id) => `/ms/updatephysicalproduct/${id}`,
  updateProductImage: (productId) => `/ms/products/${productId}/image`,
  getAllOrders: "/ms/getallorders",
  getOrderDetailsById: (id) => `/ms/getorderdetailsbyid/${id}`,
  updateShippingStatus: "/ms/updateshippingstatus",
  getAllMockTests: "/ms/getall/mocktests",
  updateMockTest: (templateId) => `/ms/updatemocktest/template/${templateId}`,
  getAllRegistrations: "/ms/getallregistrations",
  getStudentImage: (path) => `/ms/image/${path}`,
  deleteStudentRegistration: (id) => `/ms/deletestudentregistration/${id}`,
  getUserSummary: (id) => `/as/users/${id}/summary`,
  sendNotification: "/ns/notify",
  getAllSchedules: "/ns/schedules",
  getScheduleById: (id) => `/ns/schedule/${id}`,
  updateSchedule: (id) => `/ns/schedule/${id}`,
  deleteSchedule: (id) => `/ns/schedule/${id}`,
};
